export const SEARCH_DEBOUNCE_DELAY = 500;
export const MIN_PATTERN_LENGTH = 2;
